import React, { memo } from 'react'

import Composer from 'Pods/ThreeDStudio/Shared/Composer/Composer'

import Conversation from './Components/Conversation/Conversation'
import useCreateTab from './useCreateTab'

function CreateTab() {
  const {
    prompt,
    attachments,
    messages,
    tags,
    isGenerating,
    isUploadDisabled,
    fileInputRef,
    handlePromptChange,
    handleTagClick,
    handleUploadClick,
    handleRemoveAttachment,
    handleFilesChange,
    handleSend,
    handleRegenerate,
    handleGenerateAgain,
    handleApply,
    handleEdit,
  } = useCreateTab()

  const isSendDisabled = isGenerating || (!prompt.trim() && attachments.length === 0)

  return (
    <div className="image-assistant-create-tab__create">
      <Conversation
        messages={messages}
        isGenerating={isGenerating}
        onApply={handleApply}
        onRegenerate={handleRegenerate}
        onGenerateAgain={handleGenerateAgain}
        onEdit={handleEdit}
      />
      <Composer
        prompt={prompt}
        attachments={attachments}
        tags={tags}
        fileInputRef={fileInputRef}
        isSendDisabled={isSendDisabled}
        isUploadDisabled={isUploadDisabled}
        onPromptChange={handlePromptChange}
        onTagClick={handleTagClick}
        onUploadClick={handleUploadClick}
        onRemoveAttachment={handleRemoveAttachment}
        onFilesChange={handleFilesChange}
        onSend={handleSend}
      />
    </div>
  )
}

export default memo(CreateTab)
